import Api from "../config/api";

const setTokenInHeader = (token) => {
  if (token) {
    // set the token to all request to a page
    Api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    return true;
  } else {
    // delete auth token from headers
    delete Api.defaults.headers.common["Authorization"];
    return false;
  }
};

export default setTokenInHeader;
